import { ALERT } from "../constants";

const initialState = {
  alerts: [],
  total: 0,
  isLoadingGetAlerts: false,
  error: null,
};

const alertReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case ALERT.GET_ALERTS:
      return { ...state, isLoadingGetAlerts: true };
    case ALERT.GET_ALERTS_FAILURE:
      return { ...state, isLoadingGetAlerts: false, error: action.payload };
    case ALERT.GET_ALERTS_SUCCESS:
      return {
        ...state,
        isLoadingGetAlerts: false,
        alerts: action.payload.alerts,
        total: action.payload.total,
        error: null,
      };
    default:
      return state;
  }
};

export default alertReducer;
